export const photos = [
    {
        img: 'bags--cotton-bag--photo.jpg',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'cotton-bag'
        }
    },
    {
        img: 'bags--cotton-pouches--photo.png',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'cotton-pouches'
        }
    },
    {
        img: 'cartonboard--carrier-box--photo.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'carrier-box'
        }
    },
    {
        img: 'cartonboard--reverse-tuck-end--photo.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'reverse-tuck-end'
        }
    },
    {
        img: 'cartonboard--sleeve--photo.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'sleeve'
        }
    },
    {
        img: 'cartonboard--straight-tuck-end--photo.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'straight-tuck-end'
        }
    },
    {
        img: 'cartonboard--tuck-top-auto-bottom--photo.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'tuck-top-auto-bottom'
        }
    },
    {
        img: 'cartonboard--tuck-top-snap-lock-bottom--photo.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'tuck-top-snap-lock-bottom'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--3d-bottom-block-bottom--photo.jpg',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': '3d-bottom-block-bottom'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--3d-bottom-v-bottom--photo.jpg',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': '3d-bottom-v-bottom'
        }
    },
    {
        img: 'fillers--air-pillow--photo-2.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'air-pillow'
        }
    },
    {
        img: 'fillers--air-pillow--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'air-pillow'
        }
    },
    {
        img: 'fillers--bubble-wrap--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'bubble-wrap'
        }
    },
    {
        img: 'fillers--foam--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'foam'
        }
    },
    {
        img: 'fillers--honey-comb--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'honey-comb'
        }
    },
    {
        img: 'fillers--packaging-peanuts--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'packaging-peanuts'
        }
    },
    {
        img: 'fillers--shredded-cardboard--photo.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'shredded-cardboard'
        }
    },
    {
        img: 'fillers--wood-wool--photo-2.jpg',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'wood-wool'
        }
    },
    {
        img: 'fillers--wood-wool--photo.png',
        requirements: {
            type__name: 'fillers',
            'structural-design__code': 'wood-wool'
        }
    },
    {
        img: 'labels-stickers--labels-on-sheets--photo.jpg',
        requirements: {
            type__name: 'labels-stickers',
            'structural-design__code': 'labels-on-sheets'
        }
    },
    {
        img: 'plastic-bottles-caps-pump--bottle--photo.png',
        requirements: {
            type__name: 'plastic-bottles-caps-pump',
            'structural-design__code': 'bottle'
        }
    },
    {
        img: 'rigid-box--foldable--photo.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'foldable'
        }
    },
    {
        img: 'rigid-box--pedestal--photo.jpg',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'pedestal'
        }
    },
    {
        img: 'tissue--kraft-paper-sheets--photo.jpg',
        requirements: {
            type__name: 'tissue',
            'structural-design__code': 'kraft-paper-sheets'
        }
    },
    {
        img: 'bags--chalk-bags--photo-min.jpg',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'chalk-bag'
        }
    },
    {
        img: 'bags--paper-bags--photo-min.jpg',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'paper-bag'
        }
    },
    {
        img: 'cartonboard--cakebox--photo-min.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'cakebox'
        }
    },
    {
        img: 'cartonboard--drawer-box--photo-min.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'drawer-box'
        }
    },
    {
        img: 'cartonboard--pillow-box--photo-min.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'pillow-box'
        }
    },
    {
        img: 'cartonboard--two-piece--photo-min.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'two-piece'
        }
    },
    {
        img: 'corrugated--mailer-box--photo-min.jpg',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated--shipping-box--photo-min.jpg',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'shipping-box-fefco-201'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--classic--photo-min.jpg',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': 'classic'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--jiffy-bag--photo-min.jpg',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': 'jiffy-bag'
        }
    },
    {
        img: 'envelopes-courier--courier--photo-min.jpg',
        requirements: {
            type__name: 'envelopes-courier',
            'structural-design__code': 'courier'
        }
    },
    {
        img: 'flexibl-packaging--sachet--photo-min.jpg',
        requirements: {
            type__name: 'flexible-packaging',
            'structural-design__code': 'sachet'
        }
    },
    {
        img: 'flexibl-packaging--stand-up-pouch--photo-min.jpg',
        requirements: {
            type__name: 'flexible-packaging',
            'structural-design__code': 'stand-up-pouch'
        }
    },
    {
        img: 'labels-stickers--die-cut-sticker--photo-min.jpg',
        requirements: {
            type__name: 'labels-stickers',
            'structural-design__code': 'die-cut-sticker'
        }
    },
    {
        img: 'labels-stickers--reel-labels--photo-min.jpg',
        requirements: {
            type__name: 'labels-stickers',
            'structural-design__code': 'reel-labels'
        }
    },
    {
        img: 'paper-tubes--standard-tube--photo-min.jpg',
        requirements: {
            type__name: 'paper-tubes',
            'structural-design__code': 'standard-tube'
        }
    },
    {
        img: 'poly-mailers--bio-poly-mailer--photo-min.jpg',
        requirements: {
            type__name: 'poly-mailers',
            'structural-design__code': 'bio-poly-mailer'
        }
    },
    {
        img: 'poly-mailers--classic-poly-mailer--photo-min.jpg',
        requirements: {
            type__name: 'poly-mailers',
            'structural-design__code': 'classic-poly-mailer'
        }
    },
    {
        img: 'corrugated—xxx3-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx3-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx1-mailer-box—photo-1.jpg',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx1-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx2-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx2-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx4-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx4-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx5-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx5-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx6-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx6-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx7-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx7-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx8-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx8-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx9-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx9-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx10-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx10-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx11-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx11-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx12-mailer-box—photo-1.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx12-mailer-box-fefco-427'
        }
    },
    {
        img: 'rigid-box—rrr1-lid-and-bottom—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr1-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrr2-lid-and-bottom—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr2-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrr3-lid-and-bottom—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr3-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrr4-lid-and-bottom—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr4-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrt1-drawer—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt1-drawer'
        }
    },
    {
        img: 'rigid-box—rrt2-drawer—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt2-drawer'
        }
    },
    {
        img: 'rigid-box—rrt6-drawer—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt6-drawer'
        }
    },
    {
        img: 'rigid-box—rrw1-magnetic—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw1-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw2-magnetic—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw2-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw3-magnetic—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw3-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw4-magnetic—photo-1.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw4-magnetic'
        }
    }
];
//# sourceMappingURL=photos.js.map